import { Theme } from '@mui/material/styles'
import { OVERLAY_Z_INDEX } from '../zIndex'

// ----------------------------------------------------------------------

export default function Popover(theme: Theme) {
  return {
    MuiPopover: {
      styleOverrides: {
        root: {
          zIndex: OVERLAY_Z_INDEX,
        },
        paper: {
          boxShadow: theme.shadows[8],
          borderRadius: Number(theme.shape.borderRadius) * 1.5,
        },
      },
    },
  }
}
